import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Form, ModalProps } from "antd";

import { mainUrl } from "@settings";

import { FieldCorbans } from "@components/Fields/Corbans";
import { useCorban } from "@hooks/useCorban";

import { CorbanChangeModal } from "../CorbanChangeModal";
import { Wrapper } from "./styles";

type FormValues = {
  corbanId: number | null;
};

export const CorbanSelector = () => {
  const navigate = useNavigate();
  const { corbans: options, onSelectCorban, selectedCorban } = useCorban();

  const [form] = Form.useForm<FormValues>();
  const inputValue = Form.useWatch(["corbanId"], form);
  const option = options.find((o) => o.id === inputValue);

  const initialValues: FormValues = {
    corbanId: selectedCorban?.id ?? null,
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onSelect = (id: number) => {
    if (selectedCorban?.id === id) return;
    setIsModalOpen(true);
  };

  const onFinish = () => {
    if (!option) return;
    onSelectCorban(option);

    const url = option?.url ?? mainUrl;
    if (url !== location.origin) return;
    navigate("/servicos");
  };

  const onCancel: ModalProps["onCancel"] = () => {
    setIsModalOpen(false);
    form.setFieldValue("corbanId", selectedCorban?.id ?? null);
  };

  const onOk: ModalProps["onOk"] = () => {
    setIsModalOpen(false);
    form.submit();
  };

  if (options.length <= 1) return null;

  return (
    <>
      <Wrapper>
        <Form
          form={form}
          initialValues={initialValues}
          onFinish={onFinish}
          layout="vertical"
          requiredMark={false}
        >
          <FieldCorbans
            label={<span style={{ fontWeight: "bold" }}>Correspondente</span>}
            name="corbanId"
            style={{ marginBottom: 0 }}
            selectProps={{
              size: "small",
              placeholder: null,
              allowClear: false,
              onSelect,
              options,
            }}
          />
        </Form>
      </Wrapper>

      <CorbanChangeModal open={isModalOpen} onCancel={onCancel} onOk={onOk} />
    </>
  );
};
